import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "phone-input-v3" }
const _hoisted_2 = {
  key: 0,
  class: "phone-input-v3_label"
}
const _hoisted_3 = {
  key: 1,
  class: "input-v3_loader"
}

import AcPreloader from '@ui-kit/components/AcPreloader.vue'
import AcPhoneInput from '@ui-kit/components/AcPhoneInput.vue'

type PhonePayload = {
  country: string
  countryCallingCode: string
  countryCode: string
  formatted: string
  getMetadata: () => void
  nationalNumber: string
  number: string
  possible: boolean
  valid: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'PhoneInputV3'
},
  __name: 'phoneInput',
  props: {
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  required: {
    type: Boolean,
    default: false
  },
  maxlength: {
    type: Number
  },
  name: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'on-validate'],
  setup(__props, { emit: __emit }) {



const props = __props

const emit = __emit

function getPhoneValue (payload: string | PhonePayload | null | undefined): string {
  if (!payload) return ''
  if (typeof payload === 'string') return payload
  return payload.number || payload.formatted || `${payload.countryCallingCode}${payload.nationalNumber}` || ''
}

function onInputPhone (payload: string | PhonePayload | null | undefined) {
  emit('update:modelValue', getPhoneValue(payload))
}

function onValidatePhone (payload: string | PhonePayload | null | undefined) {
  emit('on-validate', payload)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(AcPhoneInput, {
      class: "phone-input-v3_input --no-border",
      value: __props.modelValue,
      placeholder: __props.placeholder,
      onOnInput: _cache[0] || (_cache[0] = ($event: any) => (onInputPhone($event))),
      onOnValidate: _cache[1] || (_cache[1] = ($event: any) => (onValidatePhone($event))),
      label: ""
    }, null, 8, ["value", "placeholder"]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(AcPreloader)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})